import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import AccountSettings from '@/components/AccountSettings';
import ProjectList from '@/components/ProjectList';
import Login from '@/components/Login';
import Register from '@/components/Register';
import Welcome from '@/components/Welcome';
import JoinOrg from '@/components/JoinOrg.vue';
import ViewDetails from '@/components/ViewDetails';
import ProjectOverview from '@/components/ProjectOverview';
import { isLoggedIn } from '@/utilities';
import logger from '@/logger';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: Login,
      name: 'Login',
    },
    {
      path: '/register',
      component: Register,
      name: 'Register',
    },
    {
      path: '/welcome',
      component: Welcome,
      name: 'Welcome',
    },
    {
      path: '/join',
      component: JoinOrg,
      name: 'JoinOrg',
    },
    {
      path: '/account',
      component: AccountSettings,
      name: 'AccountSettings',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/',
      component: Home,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'ProjectList',
          component: ProjectList,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/project/:projectId',
          name: 'Issues',
          component: ProjectOverview,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/project/:projectId/recording/:recordingId',
          name: 'ViewDetails',
          component: ViewDetails,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const loggedIn = await isLoggedIn();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!loggedIn) {
      logger.log('not logged in, so routing to /login', to);
      next({
        path: '/login',
        query: {
          redirect: to.path,
        },
      });
    } else {
      next();
    }
  } else if (to.path === '/login' || to.path === '/register') {
    if (loggedIn) {
      next({
        path: '/',
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js